import ListVehicleTransaction from "@domain/vehicle-transaction/list-vehicle-transaction/list-vehicle-transaction";
import { GetVehicleModel } from "@factory/model/query-model-vehicle";
import { Divider } from 'primereact/divider';

interface FormVehicleViewProps {
  data?: GetVehicleModel;
  imageUrl?: string;
}

function ViewField({ label, value }: { label: string; value?: string | number | null }) {
  return (
    <div className="pb-2 w-full md:w-3/4">
      <div className="text-sm text-gray-500">{label}</div>
      <div className="text-base font-medium">{value ?? '—'}</div>
    </div>
  );
}

export function FormVehicleView({ data, imageUrl }: FormVehicleViewProps) {
  return (
    <div id="FormVehicleView" className="vehicle w-full">
      <div className="grid grid-cols-1 md:grid-cols-3">
        <div className="col-span-1">
          <div className="flex flex-col items-center pb-2">
            <div className="w-32 h-32 rounded overflow-hidden bg-gray-100 flex items-center justify-center">
              {imageUrl ? (
                <img
                  src={imageUrl}
                  alt="Vehicle"
                  className="w-full h-full object-cover"
                />
              ) : (
                <span className="text-xs text-gray-400">No image</span>
              )}
            </div>
          </div>

          <Divider />

          <ViewField label="Plate Number" value={data?.plate_number} />
          <ViewField label="Make" value={data?.make} />
          <ViewField label="Model" value={data?.model} />
          <ViewField label="Year" value={data?.year} />
          <ViewField label="Color" value={data?.color} />
          <ViewField label="Nickname" value={data?.nickname} />
          <ViewField label="Remarks" value={data?.remarks} />
        </div>
        <div className="col-span-2">
          <ListVehicleTransaction />
        </div>
      </div>
    </div>
  );
}

export default FormVehicleView;
